module.exports = __webpack_public_path__ + "assets/images/ldl_g.30d07683.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/ldl_g.png
// module id = 749
// module chunks = 1